import { useState, useEffect } from 'react';
import { motion } from 'framer-motion'; 
import { FaUserGraduate, FaCheckCircle } from 'react-icons/fa';

// Updated activities with varied messages
const activities = [
    'Riya just completed the intermediate course!',
    'Aarav earned the “Public Speaking Star” badge!',
    'Akshita finished her first storytelling lesson!',
    'Apurav upgraded to the advanced program!',
    'Komal gave her first class presentation!',
    'Vansh unlocked the “Confidence Booster” challenge!',
    'Anchal shared her success with the Oracy community!',
    'Ananya completed the advanced speech course!',
    'Kabir just joined the beginner course!',
    'Amulya earned his course completion certificate!',
    'Vishrut impressed her classmates with a great speech!',
    'Vikram started his journey with the communication skills course!',
    'Abhishek won the monthly speaking challenge!',
    'Nisha aced her final communication project!',
    'Sangram gave his first group presentation today!',
    'Diya joined the “Master Storytellers” club!',
    'Ankit received a star for his persuasive speech!',
    'Aisha finished the debate skills course with top marks!',
    'Jiten unlocked his “Oracy Champion” badge!',
    'Sophia aced her confidence-building challenge!',
    'Liam just crushed his debate competition practice!',
    'Isabella shared her public speaking journey on social media!',
    'Ethan earned the “Oracy Champion” title in his advanced course!',
    'Olivia completed her first group communication project!',
    'Noah just became a certified Oracy Skills expert!',
    'Emily earned a gold star for perfecting her persuasive speech!',
    'Jacob just submitted his final communication project!',
    'Ella received an award for creative storytelling!',
    'James impressed his peers with an impromptu speech!',
    'Charlotte presented her project confidently in class!',
    'Mia won the monthly “Young Speaker of the Month” award!',
  ];

  const SocialProofToast = ({ message, show }) => (
    <motion.div
      initial={{ opacity: 0, x: '-90%' }} // Start hidden off-screen
      animate={{ opacity: show ? 1 : 0, x: show ? 0 : '-100%' }} // Animate in/out
      transition={{ duration: 0.5 }} // Animation duration
      className={`fixed bottom-4 left-4 sm:left-8 md:left-12 lg:left-16 bg-white text-black py-4 px-5 rounded-lg shadow-lg transition-all duration-300`}
      style={{
        zIndex: 9999,
        maxWidth: '300px',
        background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)', // Soft gradient background
      }}
    >
      <div className="flex items-center relative">
        {/* New Enrollment Icon */}
        <div className="relative mr-6 flex items-center">
          <FaUserGraduate className="text-theme-orange text-2xl" /> {/* Graduation Cap icon */}
          
          {/* Green Tick Icon */}
          <FaCheckCircle className="text-green-500 text-md absolute -top-2 -right-3" /> {/* Green checkmark */}
        </div>
  
        {/* Enhanced Message Text */}
        <div>
          <p className="text-md md:text-lg font-[550] text-gray-600">{message}</p>
        </div>
      </div>
    </motion.div>
  );

const LiveActivity = () => {
  const [currentMessage, setCurrentMessage] = useState('');
  const [show, setShow] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      const message = activities[Math.floor(Math.random() * activities.length)];
      setCurrentMessage(message);
      setShow(true);

      // Hide after 4 seconds
      setTimeout(() => setShow(false), 4000);
    }, 20000); // Show a new message every 6 seconds

    return () => clearInterval(interval);
  }, []);

  return <SocialProofToast message={currentMessage} show={show} />;
};

export default LiveActivity;
